export default __webpack_public_path__ + "static/canfone-logo-white-a6fb9b7e05f846374a5a54883ad81b68.png";